import cx from 'classnames';
import { motion, useTransform } from 'framer-motion';

import message1 from '@/img/amoChatsPreview/onlineChat/block_1.png';
import message2 from '@/img/amoChatsPreview/onlineChat/block_2.png';
import message3 from '@/img/amoChatsPreview/onlineChat/block_3.png';
import message4 from '@/img/amoChatsPreview/onlineChat/block_4.png';
import imageSrc5 from '@/img/amoChatsPreview/onlineChat/background.png';

import css from '../opportunities-section.module.scss';

export const AnimatedImage5 = ({ className, scrollProgressY }) => {
  const step = 0.25;
  const firstStart = 0;
  const firstEnd = 0.1;
  const opasityMsg1 = useTransform(
    scrollProgressY,
    [firstStart, firstStart + 0.001, 1],
    [0, 1, 1]
  );
  const translateMsg1 = useTransform(
    scrollProgressY,
    [firstStart, firstEnd, 1],
    [0, 0, 0]
  );
  const opasityMsg2 = useTransform(
    scrollProgressY,
    [firstStart + step, firstEnd + step, 1],
    [0, 1, 1]
  );
  const translateMsg2 = useTransform(
    scrollProgressY,
    [firstStart + step, firstEnd + step, 1],
    [10, 0, 0]
  );
  const opasityMsg3 = useTransform(
    scrollProgressY,
    [firstStart + 2 * step, firstEnd + 2 * step, 1],
    [0, 1, 1]
  );
  const translateMsg3 = useTransform(
    scrollProgressY,
    [firstStart + 2 * step, firstEnd + 2 * step, 1],
    [25, 0, 0]
  );
  const opasityMsg4 = useTransform(
    scrollProgressY,
    [firstStart + 3 * step, firstEnd + 3 * step, 1],
    [0, 1, 1]
  );
  const translateMsg4 = useTransform(
    scrollProgressY,
    [firstStart + 3 * step, firstEnd + 3 * step, 1],
    [25, 0, 0]
  );

  return (
    <div className={cx(className, css.animatedImgBlock)}>
      <img src={imageSrc5} alt='' className={css.animatedImg} />
      {/* <motion.img
        src={message1}
        alt=''
        className={css.message}
        style={{ opacity: opasityMsg1, translateY: translateMsg1 }}
      />
      <motion.img
        src={message2}
        alt=''
        className={css.message}
        style={{ opacity: opasityMsg2, translateY: translateMsg2 }}
      />
      <motion.img
        src={message3}
        alt=''
        className={css.message}
        style={{ opacity: opasityMsg3, translateY: translateMsg3 }}
      />
      <motion.img
        src={message4}
        alt=''
        className={css.message}
        style={{ opacity: opasityMsg4, translateY: translateMsg4 }}
      /> */}
    </div>
  );
};
